import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { ChevronLeft, Menu } from "@mui/icons-material";
import Sidebar from "../Sidebar/Sidebar";
import { Box, Divider, IconButton, Toolbar } from "@mui/material";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Outlet, useNavigate } from "react-router-dom";
import useStore from "../../store";
import MuiDrawer from "@mui/material/Drawer";

const drawerWidth = 300;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(7.5),
      },
    }),
  },
}));

const Page = ({ children }) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(true);

  const { logout, tenantId, data, isLoggedIn } = useStore((state) => state);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(`/?tenantId=${tenantId}`);
    }
  }, []);

  useEffect(() => {
    if (data.accessToken) {
      let exp = data?.accessToken?.payload.exp;
      let currentDate = new Date();

      // JWT exp is in seconds
      if (exp * 1000 < currentDate.getTime()) {
        logout();
        navigate(`/?tenantId=${tenantId}`);
      } else {
      }
    } else {
      navigate(`/?tenantId=${tenantId}`);
    }
  }, []);

  console.log("LAYOUT COMPONENT !");
  return (
    <>
      <Navbar />
      <Box sx={{ display: "flex" }}>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              {open ? <ChevronLeft /> : <Menu />}
            </IconButton>
          </Toolbar>
          <Divider />
          <Sidebar open={open} toggleDrawer={toggleDrawer} />
        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
          }}
        >
          {children ? children : <Outlet />}
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default Page;
